import { createApp, ref } from 'vue';
import { getLocale } from '@ts/common/language';
import { globalVueProperties } from '@ts/common/vue';
import {} from '@ts/common/datasets';
import CarbohydrateManager from '@ts/components/analysis/CarbohydrateManager.vue';
import PotentialManager from '@ts/components/analysis/PotentialManager.vue';
import Report from '@ts/components/analysis/Report.vue';
// import SelectOptionsInput from '@ts/components/SelectOptionsInput.vue';
import '@ts/pages/page-defaults';
const dataEl = document.querySelector('.hidden[data-analysis]');
const rawData = dataEl?.getAttribute('data-analysis');
if (rawData === undefined || rawData === null || rawData === '') {
    throw new Error('No analysis data found in DOM element.');
}
let analysisData;
try {
    analysisData = JSON.parse(rawData);
}
catch (error) {
    throw new Error('Failed to parse analysis data from DOM element: ' + error);
}
const app = createApp({
    setup() {
        const data = ref(analysisData);
        return {
            data,
        };
    }
});
Object.assign(app.config.globalProperties, globalVueProperties());
app.component('Report', Report);
app.component('CarbohydrateManager', CarbohydrateManager);
app.component('PotentialManager', PotentialManager);
app.mount('#app');
